import { siteConfig } from '@/mocks/siteData';

interface JsonLdProps {
  data: Record<string, unknown>;
}

export function JsonLd({ data }: JsonLdProps) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteConfig.name,
    url: `http://${siteConfig.domain}`,
    description: siteConfig.description,
    slogan: siteConfig.slogan,
    contactPoint: {
      '@type': 'ContactPoint',
      email: `contact@${siteConfig.domain}`,
      contactType: 'customer service',
    },
    sameAs: [
      `http://${siteConfig.domain}/about`,
    ],
  };
}

export function getWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteConfig.name,
    url: `http://${siteConfig.domain}`,
    description: siteConfig.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: `http://${siteConfig.domain}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };
}

export function getBreadcrumbSchema(items: Array<{ name: string; url: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}
